import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { AuthState } from '@aws-amplify/ui-components';
import { useHistory } from 'react-router-dom';
import axiosConfig from '../../utils/axiosConfig';
import { fullstory } from '../../utils/globalWindow';
import SignUp, { SignUpFormValue } from './SignUp';
import { User } from '../../interfaces/api/Auth';
import { message } from 'antd';

class SignUpContainerInterface {
  authState!: AuthState;
  setAuthState!: React.Dispatch<React.SetStateAction<AuthState>>;
  setUser!: React.Dispatch<React.SetStateAction<User | undefined>>;
}

const SignUpContainer: React.FC<SignUpContainerInterface> = ({
  authState,
  setAuthState,
  setUser
}) => {
  const [submitting, setSubmitting] = useState(false);
  const [verificationMode, setVerificationMode] = useState(false);
  const history = useHistory();

  const signInUser = (Email: string, password: string) => {
    Auth.signIn(Email, password)
      .then((userInfo) => {
        fullstory?.identify(userInfo.username, {
          email: Email
        });
        fullstory?.event('SignedUp', {
          email: Email
        });
        axiosConfig('get', `/environments`, {}, (response) => {
          Object.keys(localStorage).map((k) => {
            if (k.includes('idToken') || k.includes('accessToken')) {
              localStorage.setItem(k, 'non');
            }
            return false;
          });
          setSubmitting(false);
          setAuthState(AuthState.SignedIn);
          history.push('/');
        });
      })
      .catch((e) => {
        if (e.code === 'UserNotConfirmedException') {
          setVerificationMode(true);
        }
      });
  };
  const confirmUser = (
    Email: string,
    password: string,
    verificationCode: string
  ) => {
    Auth.confirmSignUp(Email, verificationCode)
      .then(async () => {
        signInUser(Email, password);
      })
      .catch((e) => {
        setSubmitting(false);
        message.error(e['message'], 8);
      });
  };
  const onSubmit = async (values: SignUpFormValue): Promise<void> => {
    setSubmitting(true);
    if (verificationMode) {
      confirmUser(values.Email, values.password, values.verificationCode);
    } else {
      await Auth.signUp({
        username: values.Email,
        password: values.password
      })
        .then(async () => {
          signInUser(values.Email, values.password);
          setSubmitting(false);
        })
        .catch((e) => {
          setSubmitting(false);
          message.error(e['message'], 8);
        });
    }
  };

  return (
    <SignUp
      verificationMode={verificationMode}
      submitting={submitting}
      onSubmit={onSubmit}
    />
  );
};

export default SignUpContainer;
